import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const LoadingMenu = () => {
    const listItemCount = new Array(3).fill(0);
    return (
        <>
        {
            listItemCount.map((element, index) => {
                return (
                    <li key={index} className='loading-menu-item'>
                        <Skeleton width={80} height={25} borderRadius={10} />
                    </li>
                )
            })
        }
        </>
    )
}
